export default "__VITE_ASSET__Ava$Upn3__"